import Moment from "moment";
import Calendar from "./calendar.model";
import CalendarData from "./calendar-data.model";

export default class DayCalendar extends Calendar {

    constructor(calendar) {
        super(calendar);

        this._firstHour = calendar && calendar.firstHour || 0;
        this._lastHour = calendar && calendar.lastHour || 23;

        this.init();
    }

    init() {
        this.cols = [];
        this.rows = [];

        this.cols.push(new CalendarData({
            date: Moment(this.date).startOf('day'),
            timeUnit: 'date'
        }));

        for (var h = this.firstHour; h <= this.lastHour; ++h) {
            this.rows.push(new CalendarData({
                date: Moment(this.date).hour(h),
                timeUnit: 'hour'
            }));
        }

        super.onInitComplete();
    }

    set firstHour(hour) {
        let update = this._firstHour != hour;
        if (update) {
            this._firstHour = hour;
            this.init();
        }
    }

    get firstHour() {
        return this._firstHour;
    }

    set lastHour(hour) {
        let update = this._lastHour != hour;
        if (update) {
            this._lastHour = hour;
            this.init();
        }
    }

    get lastHour() {
        return this._lastHour;
    }

    onDateUpdated(oldDate) {
        let update = this.date.year() != oldDate.year()
            || this.date.dayOfYear() != oldDate.dayOfYear();

        if (update) {
            this.cols[0].id = this.date.dayOfYear();
            this.cols[0].date = Moment(this.date).startOf('day');

            var date = Moment(this.date).startOf('day');
            this.rows.forEach(row => {
                row.date = Moment(date).hour(row.date.hour());
            });
        }
    }

    formatColTitle(col) {
        return Moment(col.date).format('dddd');
    }

    formatRowTitle(row) {
        return Moment(row.date).startOf('hour').format('HH:mm');
    }
}



// WEBPACK FOOTER //
// ./src/modules/main/components/calendar/model/day-calendar.model.js